import React, { useState, useEffect } from 'react';
import { FiCalendar, FiDownload, FiFilter, FiUsers, FiClock, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import axios from 'axios';

const AttendanceReport = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState({
    start: new Date().toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0]
  });
  const [department, setDepartment] = useState('all');

  useEffect(() => {
    fetchReports();
  }, [dateRange, department]);

  const fetchReports = async () => {
    try {
      setLoading(true);
      // TODO: Replace with actual API endpoint
      // const response = await axios.get(`${API_ENDPOINTS.base}/attendance/reports`, {
      //   params: { start: dateRange.start, end: dateRange.end, department }
      // });
      // setReports(response.data);
      
      // Mock data
      setReports([
        {
          id: 1,
          employee: 'John Doe',
          employeeId: 'EMP001',
          department: 'Production',
          date: '2024-01-15',
          checkIn: '09:00 AM',
          checkOut: '06:00 PM',
          hours: 9,
          status: 'present'
        },
        {
          id: 2,
          employee: 'Jane Smith',
          employeeId: 'EMP002',
          department: 'Quality Control',
          date: '2024-01-15',
          checkIn: '09:15 AM',
          checkOut: '05:45 PM',
          hours: 8.5,
          status: 'present'
        }
      ]);
    } catch (error) {
      console.error('Error fetching reports:', error);
    } finally {
      setLoading(false);
    }
  };

  const stats = {
    totalEmployees: 125,
    present: 118,
    absent: 5,
    late: 2,
    onLeave: 0
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
            <FiCalendar className="text-blue-600" />
            Attendance Report
          </h1>
          <p className="text-gray-600 mt-1">Employee attendance tracking and analytics</p>
        </div>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2">
          <FiDownload /> Export Report
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
        <div className="bg-white rounded-lg shadow-md p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total Employees</p>
              <p className="text-2xl font-bold text-gray-800">{stats.totalEmployees}</p>
            </div>
            <FiUsers className="text-blue-600 text-2xl" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Present</p>
              <p className="text-2xl font-bold text-green-600">{stats.present}</p>
            </div>
            <FiCheckCircle className="text-green-600 text-2xl" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Absent</p>
              <p className="text-2xl font-bold text-red-600">{stats.absent}</p>
            </div>
            <FiXCircle className="text-red-600 text-2xl" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Late</p>
              <p className="text-2xl font-bold text-yellow-600">{stats.late}</p>
            </div>
            <FiClock className="text-yellow-600 text-2xl" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">On Leave</p>
              <p className="text-2xl font-bold text-blue-600">{stats.onLeave}</p>
            </div>
            <FiCalendar className="text-blue-600 text-2xl" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
            <input
              type="date"
              value={dateRange.start}
              onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
            <input
              type="date"
              value={dateRange.end}
              onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Department</label>
            <select
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="all">All Departments</option>
              <option value="production">Production</option>
              <option value="quality">Quality Control</option>
              <option value="sales">Sales</option>
              <option value="admin">Administration</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50 border-b">
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Employee</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Employee ID</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Department</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Date</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Check In</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Check Out</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Hours</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Status</th>
                </tr>
              </thead>
              <tbody>
                {reports.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-12 text-gray-500">
                      No attendance records found
                    </td>
                  </tr>
                ) : (
                  reports.map((report) => (
                    <tr key={report.id} className="border-b hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-900">{report.employee}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.employeeId}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.department}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.date}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.checkIn}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.checkOut}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{report.hours} hrs</td>
                      <td className="px-4 py-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          report.status === 'present' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                        }`}>
                          {report.status}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AttendanceReport;

